import React from "react";
import classes from "./PageHeading.module.css";
export default function PageHeading(props) {
  return <h2 className={classes.pageHeading}>{props.children}</h2>;
}
